<p class="text-muted-color font-light text-sm">{{ label() }}</p>
@let val = value();
@if (copy() && val) {
  <app-copy-button [value]="val"/>
} @else {
  @if (val) {
    @if (tagFunction(); as func) {
      <p-tag [severity]="func(val)">{{ value() }}</p-tag>
    } @else if (val) {
      <p>{{ val }}</p>
    }
  } @else {
    <p>-</p>
  }
}
